<template>
  <div>
    <div class="container">
      <CreateTitle :title="page_title"/>

      <div class="create">
        <loader :isLoading="requestInProgress"/>

        <div class="row">
          <div class="col-sm">
            <CreatePageImage :src="image.url" :alt="image.alt" :width="image.width" />
          </div>

          <div class="col-sm form-container">
            <form @submit.prevent="submit" id="form-create" novalidate>

              <div class="form-components-combined">
                <label>Mobile Number</label>
                <VuePhoneNumberInput
                  phoneNumberLabel="Mobile Number"
                  v-model="form.company_phone"
                  default-country-code="PH"
                  :only-countries="['PH']"
                  color="#00386A"
                  valid-color="#20c997"
                />
                <small
                  v-if="error.company_phone"
                  v-show="error.company_phone"
                  data-type="message"
                  class="form-text text-muted error-message">
                  {{ error.company_phone }}
                </small>
              </div>

              <!-- REFACTOR THIS PART -->
              <div class="form-group">
                <label for="building-type">
                  Where do you intend to use YeyPass?
                </label>

                <div class="form-check-container">
                  <div class="form-check">
                    <input
                      v-model="form.building_type"
                      class="form-check-input"
                      type="radio"
                      name="building-type"
                      id="for-building-type-hotel"
                      value="Hotel">
                    <label class="form-check-label" for="for-building-type-hotel">
                      Hotel
                    </label>
                  </div>
                  <div class="form-check">
                    <input v-model="form.building_type"
                      class="form-check-input"
                      type="radio"
                      name="building-type"
                      id="for-building-type-building"
                      value="Condo" >
                    <label class="form-check-label" for="for-building-type-building">
                      Condo
                    </label>
                  </div>
                  <div class="form-check">
                    <input v-model="form.building_type"
                      class="form-check-input"
                      type="radio"
                      name="building-type"
                      id="for-building-type-office"
                      value="Office">
                    <label class="form-check-label" for="for-building-type-office">
                      Company Office
                    </label>
                  </div>
                  <div class="form-check">
                    <input v-model="form.building_type"
                      class="form-check-input"
                      type="radio" name="building-type"
                      id="for-building-type-building"
                      value="Building Premises">
                    <label class="form-check-label" for="for-building-type-building">
                      Building premises
                    </label>
                  </div>
                  <div class="form-check">
                    <input v-model="form.building_type"
                      class="form-check-input"
                      type="radio"
                      name="building-type"
                      id="for-building-type-co-working-space"
                      value="Co-working Space" >
                    <label class="form-check-label" for="for-building-type-co-working-space">
                      Co-Working Space
                    </label>
                  </div>
                  <div class="form-check">
                    <input v-model="form.building_type"
                      class="form-check-input"
                      type="radio"
                      name="building-type"
                      id="for-building-type-school"
                      value="School" >
                    <label class="form-check-label" for="for-building-type-school">
                      School
                    </label>
                  </div>
                  <div class="form-check">
                    <input v-model="form.building_type"
                      class="form-check-input"
                      type="radio"
                      name="building-type"
                      id="for-building-type-event-pass"
                      value="Event Pass" >
                    <label class="form-check-label" for="for-building-type-event-pass">
                      Event Pass (for event organizers)
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      v-model="form.building_type"
                      class="form-check-input"
                      type="radio"
                      name="building-type"
                      id="for-building-type-other"
                      value="Others" >
                    <label
                      class="form-check-label"
                      for="for-building-type-other">
                      <input
                        id="other-building-type"
                        v-model="form.other_building_type"
                        type="text"
                        name="other_reason"
                        placeholder="Others" />
                    </label>

                    <small
                      v-if="form.building_type === 'Others' && !form.other_building_type"
                      v-show="error.building_type_others"
                      data-type="message"
                      class="form-text text-muted error-message">
                      {{ error.building_type_others }}
                    </small>
                  </div>
                </div>

                <small
                  v-if="error.building_type"
                  v-show="error.building_type"
                  data-type="message"
                  class="form-text text-muted error-message">
                  {{ error.building_type }}
                </small>
              </div>
              <!-- END REFACTOR -->

              <InputComponent
                type="text"
                maxlength="250"
                for="input-company-background"
                label_text="Company Background"
                attribute="Company Background"
                placeholder="Tells us a short info about what is your company and what it does."
                v-model="form.company_info"
                :v="$v.form.company_info" />

              <div class="form-group">
                <label for="building-owner">
                  Are you responsible of the entire establishment?
                  Eg. Handles concierge and receptions or supervision of the building premises?
                </label>

                <div class="form-check-container">
                  <div class="form-check form-check-inline">
                    <input v-model="form.is_building_owner"
                      class="form-check-input"
                      type="radio"
                      name="for-building-owner"
                      id="yes-building-owner" value="true">
                    <label class="form-check-label" for="yes-building-owner">Yes</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input v-model="form.is_building_owner"
                      class="form-check-input"
                      type="radio"
                      name="for-building-owner"
                      id="no-building-owner"
                      value="false">
                    <label class="form-check-label" for="yes-building-owner">No</label>
                  </div>
                </div>

                <small
                  v-if="!form.is_building_owner"
                  v-show="error.is_building_owner"
                  data-type="message"
                  class="form-text text-muted error-message">
                  {{ error.is_building_owner }}
                </small>
              </div>

              <!-- Submit Button -->
              <div class="text-center">
                <small
                  data-type="message"
                  class="form-text text-muted"
                  v-if="errorMessage">
                  {{ errorMessage }}
                </small>

                <button type="submit" class="btn btn-primary">Next</button>
              </div>

            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'

import { required } from 'vuelidate/lib/validators'
import { hasReached250Characters } from "@/form-validators"

import 'vue-phone-number-input/dist/vue-phone-number-input.css'

import CreateTitle from '@/components/common/CreateTitle'
import CreatePageImage from '@/components/common/CreatePageImage'
import Loader from '@/components/common/Loader'

import InputComponent from '@/components/form/InputComponent'

import { ASSET_CREATE_PROFILE_1 } from '@/api/constants/ImageAssets'
import { APIService } from '@/api/APIService'

const api = new APIService()

export default {
  components: {
    CreateTitle,
    CreatePageImage,
    InputComponent,
    VuePhoneNumberInput,
    Loader
  },
  props: {
    companyId: String,
    updateIsOrganizer: Function,
    setDataIsOrganizer: Function
  },
  data() {
    return {
      page_title: "Create Company Profile",
      image: ASSET_CREATE_PROFILE_1,
      form: {
        company_info: '',
        company_phone: '',
        building_type: '',
        other_building_type: '',
        is_building_owner: ''
      },
      error: {
        company_phone: '',
        company_info: '',
        building_type: '',
        building_type_others: '',
        is_building_owner: '',
        message: ''
      },
      haveErrors: false,
      text_info_length: '250 characters max',
      requestInProgress: false,
      errorMessage: ''
    }
  },
  validations: {
    form: {
      company_info: { required, hasReached250Characters }
    }
  },
  methods: {
    submit() {
      this.$v.$touch()
      this.error = {}

      // Check errors on all
      if(!this.form.building_type) {
        this.error.building_type = 'Please select a building type'
        this.errorCheckBuildingType = true
      } else {
        this.errorCheckBuildingType = false
      }

      if(this.form.building_type === 'Others') {
        if(this.form.other_building_type){
          this.form.building_type = 'others_' + this.form.other_building_type
          this.errorCheckOtherBuildingType = false
        } else {
          this.error.building_type_others = 'Please fill-in what type of building you have'
          this.errorCheckOtherBuildingType = true
        }
      }

      if(!this.form.company_phone.length) {
        this.error.company_phone = 'Phone is required. Please follow the required format for phone number.'
        this.errorCheckCompanyPhone = true
        this.errorCheckCompanyPhoneCount = true
      } else if (this.form.company_phone.length < 12) {
        this.error.company_phone = 'Please follow the required format for phone number.'
        this.errorCheckCompanyPhoneCount = true
      } else {
        this.errorCheckCompanyPhone = false
        this.errorCheckCompanyPhoneCount = false
      }

      if(!this.form.is_building_owner.length) {
        this.error.is_building_owner = 'Please select if you\'re the building owner.'
        this.errorBuildingOwnerType = true
      } else {
        this.errorBuildingOwnerType = false
      }

      if (!this.$v.$invalid &&
          !this.errorCheckCompanyPhoneCount &&
          !this.errorBuildingOwnerType &&
          !this.errorCheckBuildingType &&
          !this.errorCheckOtherBuildingType) {

        if(this.form.building_type === 'Event Pass') {
          this.form.is_event_organizer = true
          this.updateIsOrganizer(true)
        } else {
          this.form.is_event_organizer = false
          this.updateIsOrganizer(false)
        }
        this.setDataIsOrganizer()
        this.updateProfileFields()
      }
    },
    updateProfileFields() {
      // TODO: add check if previous profile was skipped
      var self = this
      var fields = {
        company_details: { ...this.form }
      }

      self.requestInProgress = true
      api.updateCompanyProfile(self.companyId, fields).then(data => {
        self.requestInProgress = false
        if(data){
          if(data.statusCode === 200) self.redirectToPage()
          else self.errorMessage = data.message
        } else {
          self.error.message = 'session expired'
        }
      }).catch(err => {
        self.requestInProgress = false
        if(err.message) self.errorMessage = err.message
        else self.errorMessage = err
      })
    },
    redirectToPage() {
      this.$router.push(`/create-profile/business/${this.companyId}/photo`)
    }
  }
}

</script>

<style>
  @import '../../assets/styles/form-style-1.css'
</style>

<style scoped>
  .form-components-combined {
    padding-top: 0px;
  }

  .vue-phone-number-input {
    padding-top: 20px;
  }

  #other-building-type {
    border: none;
    border-bottom: 1px solid #E5E9EB;
    color: #00386A;
    width: 120%;
  }

  #other-building-type::-webkit-input-placeholder { /* Edge */
    color: #C6DAEF;
  }

  #other-building-type:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #C6DAEF;
  }

  #other-building-type::placeholder {
    color: #C6DAEF;
  }

  #other-building-type:focus {
    outline: none !important;
    border-bottom: 1px solid #00386A;
  }
</style>



// WEBPACK FOOTER //
// src/containers/business_profile/CreateBusinessProfileInfo.vue